import {Button, Divider, Row, Space} from "antd";
import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import AppearanceExpand from "../components/AppearanceExpand/AppearanceExpand";
import InjuryExpand from "../components/InjuryExpand/InjuryExpand";
import AppendAgesExpand from "../components/AppendAgesExpand/AppendAgesExpand";
import ConjunctivaExpand from "../components/ConjunctivaExpand/ConjunctivaExpand";
import ScleraExpand from "../components/ScleraExpand/ScleraExpand";
import CorneaExpand from "../components/CorneaExpand/CorneaExpand";
import AnteriorExpand from "../components/AnteriorExpand/AnteriorExpand";
import PupilExpand from "../components/PupilExpand/PupilExpand";
import IrisExpand from "../components/IrisExpand/IrisExpand";
import LensExpand from "../components/LensExpand/LensExpand";
import ExtraocularExpand from "../components/ExtraocularExpand/ExtraocularExpand";
import IntraocularExpand from "../components/IntraocularExpand/IntraocularExpand";
import GonioscopyExpand from "../components/GonioscopyExpand/GonioscopyExpand";
import FundusExpand from "../components/FundusExpand/FundusExpand";
import {useAppSelector} from "redux/hooks";
import {
  normalAnterior,
  normalAppearance,
  normalAppendage,
  normalConjuctiva,
  normalCornea,
  normalIris,
  normalLens,
  normalPupil,
  normalSclera,
} from "../ExamTab.config";

const LeftEye = forwardRef((props: any, ref) => {
  const [isOpenAppearance, setIsOpenAppearance] = useState<boolean>(false);
  const [isOpenAnterior, setIsOpenAnterior] = useState<boolean>(false);
  const [isOpenAppendAges, setIsOpenAppendAges] = useState<boolean>(false);
  const [isOpenConjunctiva, setIsOpenConjunctiva] = useState<boolean>(false);
  const [isOpenCornea, setIsOpenCornea] = useState<boolean>(false);
  const [isOpenExtraocular, setIsOpenExtraocular] = useState<boolean>(false);
  const [isOpenFundus, setIsOpenFundus] = useState<boolean>(false);
  const [isOpenGonioscopy, setIsOpenGonioscopy] = useState<boolean>(false);
  const [isOpenInjury, setIsOpenInjury] = useState<boolean>(false);
  const [isOpenIntraocular, setIsOpenIntraocular] = useState<boolean>(false);
  const [isOpenIris, setIsOpenIris] = useState<boolean>(false);
  const [isOpenLends, setIsOpenLends] = useState<boolean>(false);
  const [isOpenPupil, setIsOpenPupil] = useState<boolean>(false);
  const [isOpenSclera, setIsOpenSclera] = useState<boolean>(false);
  const formRef = useAppSelector(state => state.examination.ref);
  useImperativeHandle(ref, () => ({
    clearAll: () => {
      clearAll();
    },
  }));
  const clearAll = () => {
    setIsOpenAnterior(false);
    setIsOpenAppearance(false);
    setIsOpenAppendAges(false);
    setIsOpenConjunctiva(false);
    setIsOpenCornea(false);
    setIsOpenExtraocular(false);
    setIsOpenFundus(false);
    setIsOpenGonioscopy(false);
    setIsOpenInjury(false);
    setIsOpenIntraocular(false);
    setIsOpenIris(false);
    setIsOpenLends(false);
    setIsOpenPupil(false);
    setIsOpenSclera(false);
  };
  const openNormal = () => {
    setIsOpenAppearance(true);
    setIsOpenAppendAges(true);
    setIsOpenConjunctiva(true);
    setIsOpenSclera(true);
    setIsOpenCornea(true);
    setIsOpenAnterior(true);
    setIsOpenPupil(true);
    setIsOpenIris(true);
    setIsOpenLends(true);
    setIsOpenExtraocular(true);
  };
  const setNormalValues = (name, normalValues) => {
    Object.entries(normalValues).forEach(([key, value]) => {
      formRef.setFieldValue(["leftJsonValue", name, key], value);
    });
  };
  const handleNormalValues = () => {
    openNormal();
    setNormalValues("APPEARANCE", normalAppearance);
    setNormalValues("APPENDAGES", normalAppendage);
    setNormalValues("CONJUNCTIVA", normalConjuctiva);
    setNormalValues("SCLERA", normalSclera);
    setNormalValues("CORNEA", normalCornea);
    setNormalValues("ANTERIOR_CHAMBER", normalAnterior);
    setNormalValues("PUPIL", normalPupil);
    setNormalValues("IRIS", normalIris);
    setNormalValues("LENS", normalLens);
  };
  const changeIsOpenAnterior = () => {
    setIsOpenAnterior(!isOpenAnterior);
  };
  const changeIsOpenAppendAges = () => {
    setIsOpenAppendAges(!isOpenAppendAges);
  };
  const changeIsOpenConjunctiva = () => {
    setIsOpenConjunctiva(!isOpenConjunctiva);
  };
  const changeIsOpenCornea = () => {
    setIsOpenCornea(!isOpenCornea);
  };
  const changeIsOpenExtraocular = () => {
    setIsOpenExtraocular(!isOpenExtraocular);
  };
  const changeIsOpenFundus = () => {
    setIsOpenFundus(!isOpenFundus);
  };
  const changeIsOpenGonioscopy = () => {
    setIsOpenGonioscopy(!isOpenGonioscopy);
  };
  const changeIsOpenInjury = () => {
    setIsOpenInjury(!isOpenInjury);
  };
  const changeIsOpenIntraocular = () => {
    setIsOpenIntraocular(!isOpenIntraocular);
  };
  const changeIsOpenIris = () => {
    setIsOpenIris(!isOpenIris);
  };
  const changeIsOpenLends = () => {
    setIsOpenLends(!isOpenLends);
  };
  const changeIsOpenPupil = () => {
    setIsOpenPupil(!isOpenPupil);
  };
  const changeIsOpenSclera = () => {
    setIsOpenSclera(!isOpenSclera);
  };
  const changeIsOpenAppearance = () => {
    setIsOpenAppearance(!isOpenAppearance);
  };
  return (
    <div className="left-eye">
      <Space
        direction="vertical"
        className="healthy-detail-space"
        size={"small"}
      >
        <Row>
          <div className="header-side">
            <Button
              className="btn-20 left"
              size="small"
              type="primary"
              onClick={handleNormalValues}
            >
              Bình thường
            </Button>
            <div>Mắt trái </div>
            <Button
              className="btn-20 right"
              size="small"
              danger
              type="primary"
              onClick={clearAll}
            >
              Xóa triệu chứng
            </Button>
          </div>
        </Row>
        <AppearanceExpand
          index={1}
          isOpen={isOpenAppearance}
          setIsOpen={changeIsOpenAppearance}
          // values={values}
          // setValues={setValues}
        />
        <Divider className="divider-no-margin" />
        <InjuryExpand
          index={1}
          isOpen={isOpenInjury}
          setIsOpen={changeIsOpenInjury}
        />
        <Divider className="divider-no-margin" />
        <AppendAgesExpand
          index={1}
          isOpen={isOpenAppendAges}
          setIsOpen={changeIsOpenAppendAges}
        />
        <Divider className="divider-no-margin" />
        <ConjunctivaExpand
          index={1}
          isOpen={isOpenConjunctiva}
          setIsOpen={changeIsOpenConjunctiva}
        />
        <Divider className="divider-no-margin" />
        <ScleraExpand
          index={1}
          isOpen={isOpenSclera}
          setIsOpen={changeIsOpenSclera}
        />
        <Divider className="divider-no-margin" />
        <CorneaExpand
          index={1}
          isOpen={isOpenCornea}
          setIsOpen={changeIsOpenCornea}
        />
        <Divider className="divider-no-margin" />
        <AnteriorExpand
          index={1}
          isOpen={isOpenAnterior}
          setIsOpen={changeIsOpenAnterior}
        />
        <Divider className="divider-no-margin" />
        <PupilExpand
          index={1}
          isOpen={isOpenPupil}
          setIsOpen={changeIsOpenPupil}
        />
        <Divider className="divider-no-margin" />
        <IrisExpand
          index={1}
          isOpen={isOpenIris}
          setIsOpen={changeIsOpenIris}
        />
        <Divider className="divider-no-margin" />
        <LensExpand
          index={1}
          isOpen={isOpenLends}
          setIsOpen={changeIsOpenLends}
        />
        <Divider className="divider-no-margin" />
        <ExtraocularExpand
          index={1}
          isOpen={isOpenExtraocular}
          setIsOpen={changeIsOpenExtraocular}
        />
        <Divider className="divider-no-margin" />
        <IntraocularExpand
          index={1}
          isOpen={isOpenIntraocular}
          setIsOpen={changeIsOpenIntraocular}
        />
        <Divider className="divider-no-margin" />
        <GonioscopyExpand
          index={1}
          isOpen={isOpenGonioscopy}
          setIsOpen={changeIsOpenGonioscopy}
        />
        <Divider className="divider-no-margin" />
        <FundusExpand
          index={1}
          isOpen={isOpenFundus}
          setIsOpen={changeIsOpenFundus}
        />
      </Space>
    </div>
  );
});
export default LeftEye;
